import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import Link from 'next/link'
import classes from '../styles/section.module.css'

const VirtualCare = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div>
          <div className="relative">
            <div className="absolute inset-x-0 bottom-0 h-1/2" />
            <div className="mx-auto">
              <div className="relative">
                <div className="absolute inset-0">
                  <img
                    className="object-cover w-full h-full"
                    src="conferenceroomtalk.png"
                    alt="Team meeting in a conference room"
                  />
                </div>
                <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                  <h1 className="text-3xl tracking-tight md:text-5xl">
                    <span className="block text-blue-dark">
                      No copay. No deductible.
                    </span>
                    <span className="block py-2 text-globeGreen">
                      Talk to a board-certified physician 24/7 for $0.
                    </span>
                  </h1>
                  <p className="max-w-lg mt-6 text-xl text-grey sm:max-w-3xl">
                    Available on-demand by phone and video. Just the primary and
                    specialty care you want, when you need it most.
                  </p>

                  <a
                    href="https://doctorondemand.com/microsite/evryhealth/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="inline-block px-10 py-2 mt-8 text-xl bg-transparent border-2 text-blue border-blue hover:bg-blue hover:text-white-light">
                      Sign in
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <main>
          <section>
            <div className="max-w-screen-xl px-4 py-12 mx-auto md:py-0 sm:px-6 lg:px-8">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                <div className="px-4 lg:col-span-1">
                  <h2 className="text-4xl tracking-tight font-extralight">
                    <span className="block text-blue-dark">
                      Evry makes it easy
                    </span>
                    <span className="block text-blue">
                      to get great virtual care.
                    </span>
                  </h2>
                  <p className="max-w-lg mt-6 text-lg text-grey sm:max-w-3xl">
                    We offer 24/7 telehealth access, with unlimited visits to
                    primary care and certain specialists.
                  </p>
                </div>
                <div className="mt-8 lg:col-span-1 md:mt-0">
                  <div className={`flex items-center justify-center h-full`}>
                    <figure
                      className={`${classes.sectionImageRightVirtualCare}`}
                    >
                      <img
                        className={`${classes.virtualCareLady} h-full w-full object-cover`}
                        src="https://content.evryhealth.com/MarketingImages/public%20(12).webp"
                        alt="Lady smiling"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="bg-white">
              <div className="max-w-screen-xl px-8 py-16 mx-auto lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                  <div className="lg:col-span-1">
                    <h2 className="text-4xl tracking-tight text-blue-dark">
                      All from your home for $0.
                    </h2>
                    <ul className="pt-6 text-xl text-darkBlue">
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="checkmark.svg"
                        ></object>
                        <p className="inline pl-4">
                          Post-visit lab work & imaging
                        </p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="checkmark.svg"
                        ></object>
                        <p className="inline pl-4">New prescriptions</p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="checkmark.svg"
                        ></object>
                        <p className="inline pl-4">Renew old prescriptions</p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="checkmark.svg"
                        ></object>
                        <p className="inline pl-4">Follow-up appointments</p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="checkmark.svg"
                        ></object>
                        <p className="inline pl-4">
                          Control over your own medical records
                        </p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="x-red.svg"
                        ></object>
                        <p className="inline pl-4">
                          Waiting weeks to get into the doctor’s office
                        </p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="x-red.svg"
                        ></object>
                        <p className="inline pl-4">Office visits</p>
                      </li>
                      <li className="mt-4">
                        <object
                          className="inline-block h-6"
                          type="image/svg+xml"
                          data="x-red.svg"
                        ></object>
                        <p className="inline pl-4">Copays</p>
                      </li>
                    </ul>
                  </div>
                  <div className="lg:col-span-1">
                    <div className="flex items-center justify-center h-full mt-10 md:mt-0"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="max-w-screen-xl px-4 py-12 mx-auto md:py-0 sm:px-6 lg:px-8">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                <div className="py-32 lg:col-span-1">
                  <h2 className="pb-12 text-2xl tracking-tight font-extralight sm:text-3xl lg:text-4xl">
                    <span className="block text-blue-dark">How It Works</span>
                  </h2>
                  <ol
                    className={`${classes.numberedList} pl-6 md:pl-16 text-xl text-grey`}
                  >
                    <li className="py-3">
                      <p>
                        Select “Talk to a Doctor Now” on your Member Portal or
                        Evry Mobile App.
                      </p>
                    </li>
                    <li className="py-3">
                      <p>
                        Complete a quick, one-time questionnaire and profile for
                        you and your children.
                      </p>
                    </li>
                    <li className="py-3">
                      <p>
                        Pick the type of doctor you need and whether you want to
                        visit them by phone, web, or app.
                      </p>
                    </li>
                    <li className="py-3">
                      <p>
                        Choose to see someone immediately on-demand or schedule
                        an appointment with your preferred doctor.
                      </p>
                    </li>
                    <li className="py-3">
                      <p>See your doctor from the convenience of anywhere.</p>
                    </li>
                    <li className="py-3">
                      <p>
                        You’ll get summary notes back from the doctor after your
                        visit.
                      </p>
                    </li>
                  </ol>
                </div>
                <div className="lg:col-span-1">
                  <div className="flex items-center justify-center h-full">
                    <img
                      className={`${classes.virtualCarePhone} object-cover`}
                      src="Virtual_Care_Phone.png"
                      alt="Phone with profile contact "
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-white-light">
            <h2 className="text-4xl font-light text-center text-darkBlue">
              Covered Specialties.
            </h2>
            <div className="grid grid-cols-12 pt-16 text-center">
              <div className="col-span-12 py-4 md:col-span-4 md:py-16 md:px-16">
                <object
                  className="py-2 mx-auto"
                  data="stethescope-blue.svg"
                  alt="stethoscope"
                />
                <h4 className="text-2xl md:text-3xl text-darkBlue">
                  General Medical
                </h4>
                <p className="px-12 py-6 md:px-10 text-grey-dark">
                  See experienced U.S. board-certified adult and pediatric
                  doctors who can help you with anything. From cold and flu to
                  allergies to COVID-19, these physicians can help diagnose,
                  treat, and prescribe medication for you.
                </p>
              </div>
              <div className="col-span-12 py-8 md:col-span-4 md:px-16">
                <object
                  className="py-2 mx-auto md:py-6"
                  data="sexual-blue.svg"
                  alt="stethoscope"
                />
                <h4 className="text-2xl md:text-3xl text-darkBlue">
                  Sexual Health
                </h4>
                <p className="px-12 py-6 md:px-10 text-grey-dark">
                  Get confidential lab tests for common sexually transmitted
                  diseases along with a consultation with specially trained
                  physicians. Results are always completely confidential and
                  never reported back to us or your employer, so that you can
                  get the care you need with the privacy you deserve.
                </p>
              </div>
              <div className="col-span-12 py-8 md:col-span-4 md:py-16 md:px-16">
                <object
                  className="py-2 mx-auto md:py-2"
                  data="smileyface-blue.svg"
                  alt="stethoscope"
                />
                <h4 className="text-2xl md:text-3xl text-darkBlue">
                  Behavioral Health
                </h4>
                <p className="px-12 py-6 md:px-0 text-grey-dark">
                  We&lsquo;ve gone through great lengths to make sure
                  board-certified psychiatrists, licensed psychologists, and
                  therapists are available to serve you wherever you feel most
                  comfortable. Whether you&lsquo;re battling severe depression
                  or just need an outside perspective, we encourage you to take
                  full advantage of these professionals.
                </p>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </>
  )
}

export default VirtualCare
